import React from "react";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";
import {
  TranslationKeys,
} from "../../../infrastructure/const";
import Spinner from "../../common/spinner";
import {
  MandatoryCheckboxesRefs,
} from "../../common/mandatory-checkboxes/mandatory-checkboxes-section";
import TermsAndConditionsCheckboxes from "../common/terms-and-conditions-checkboxes";
import Captcha from "../../common/captcha";

type CheckoutSummaryProps = {
  onContinueClick: (
    checkboxesSelected: Array<string>,
    areAllMandatoryCheckboxesSelected: boolean,
    captchaV2Token: string,
    captchaV3Token: string
  ) => void;
  isLoaded: boolean;
  displayValidationMessages: boolean;
  invoiceAddressApiIsIncorrect: boolean;
  deliveryAddressApiIsIncorrect: boolean;
  apiErrorResponse: Array<string>;
  showCaptchaV2: boolean;
};

type CheckoutSummaryState = {
  captchaV2Token: string;  
  captchaError: string;
  captchaHasError: boolean;
};

declare global {
  interface Window {
    grecaptcha?: any;
  }
}

export default class CheckoutBatterySummary extends React.Component<
  CheckoutSummaryProps,
  CheckoutSummaryState
> {
  private TranslationManager: TranslationManager;
  private translations: { [id: string]: string };
  private checkboxesRef: React.RefObject<MandatoryCheckboxesRefs>;

  constructor(props: CheckoutSummaryProps, context: ITranslationsContext) {
    super(props, context);
    this.state = {
      captchaV2Token: '',
      captchaError: '',
      captchaHasError: false,
      showCaptchaV2: false
    } as CheckoutSummaryState;

    this.TranslationManager = new TranslationManager(this.context);

    this.translations = {
      continue: this.TranslationManager.getTranslation(
        TranslationKeys.CONTINUE
      ),
      orderSummary: this.TranslationManager.getTranslation(
        TranslationKeys.CART_ORDERSUMMARY_HEADER
      ),
      captchaInvalidRequest: this.TranslationManager.getTranslation(
        TranslationKeys.CAPTCHA_INVALID_REQUEST
      ),
      captchaInvalidToken: this.TranslationManager.getTranslation(
        TranslationKeys.CAPTCHA_INVALID_TOKEN
      ),
      invoiceAddressApiIncorrect: this.TranslationManager.getTranslation(
        TranslationKeys.ADDRESSAPI_ADDRESS_INVOICE_INCORRECT
      ),
      deliveryAddressApiIncorrect: this.TranslationManager.getTranslation(
        TranslationKeys.ADDRESSAPI_ADDRESS_DELIVERY_INCORRECT
      ),
    };

    this.checkboxesRef = React.createRef<MandatoryCheckboxesRefs>();
    this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
    this.handleCaptchaErrorOrExpired = this.handleCaptchaErrorOrExpired.bind(this);
    this.getRecaptchaToken = this.getRecaptchaToken.bind(this);
    this.onContinueClick = this.onContinueClick.bind(this);
  }

  onContinueClick(captchaV3Token: string): void {

    if(this.props.showCaptchaV2 && (!this.state.captchaV2Token || this.state.captchaHasError)) {
      return;
    }

    if(!this.props.showCaptchaV2 && (!captchaV3Token || this.state.captchaHasError)) {
      return;
    }

    let selectedCheckboxes: Array<string>;
    let areAllCheckboxesSelected: boolean;
    if (
      this.checkboxesRef !== undefined &&
      this.checkboxesRef !== null &&
      this.checkboxesRef.current !== null &&
      this.checkboxesRef.current !== undefined
    ) {
      selectedCheckboxes = this.checkboxesRef.current.getSelectedCheckboxesList();
      areAllCheckboxesSelected = this.checkboxesRef.current.allCheckboxesSelected();


      this.props.onContinueClick(selectedCheckboxes, areAllCheckboxesSelected, this.state.captchaV2Token, captchaV3Token);
    }
  }

  componentDidMount(): void {
      // Add reCaptcha
      if(!window.grecaptcha) {
        const script = document.createElement("script")
        script.id = "recaptchaV3";
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHA_SITE_KEY_V3}`
        document.body.appendChild(script)
      }
  }

  componentWillUnmount(): void {
      let recaptchaV3Script = document.getElementById("recaptchaV3");
      if(recaptchaV3Script) {
        recaptchaV3Script.remove();
      }
  }

  getRecaptchaToken(action: string): void {
      let grecaptcha = window.grecaptcha;
      grecaptcha.ready(() => {
          grecaptcha
          .execute(process.env.REACT_APP_CAPTCHA_SITE_KEY_V3, { action: action })
          .then((token: string) => {
              this.onContinueClick(token);
          })
      })
  }

  handleCaptchaChange(token: string | null): void {
    if (!token) {
        return;
    }
    this.setState({ captchaV2Token: token, captchaHasError: false });
  }

  handleCaptchaErrorOrExpired(): void {
      this.setState({ captchaV2Token: '', captchaError: this.translations.captchaInvalidRequest, captchaHasError: true });
  }

  render(): JSX.Element {
    return (
      <li id="opc-review">
        <div id="checkout-step-review" className="checkout-step">
          <div className="checkout-step__title">
            <span className="text">{this.translations.orderSummary}</span>
          </div>
          <div className="content-container">
            {this.props.isLoaded ? (
              <div className="checkout-final">
                <div id="checkout-review-load" className="default-box">
                  <TermsAndConditionsCheckboxes
                    displayValidationMessages={
                      this.props.displayValidationMessages
                    }
                    checkboxesRef={this.checkboxesRef}
                  />
                </div>
                {this.props.showCaptchaV2 && <Captcha 
                  hasError={this.state.captchaHasError} 
                  onChange={this.handleCaptchaChange} 
                  onExpiration={this.handleCaptchaErrorOrExpired} 
                  onError={this.handleCaptchaErrorOrExpired} />}                    
                <div
                  className="g-recaptcha"
                  data-sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY_V3}
                  data-size="invisible"
                ></div>
                {this.state.captchaHasError && <div className="validation-advice"><span className="icon-arrow-up"></span>{this.state.captchaError}</div>}   
                {(this.props.apiErrorResponse && (this.props.apiErrorResponse.indexOf("CaptchaV2Token") || this.props.apiErrorResponse.indexOf("CaptchaV3Token"))) && <div className="validation-advice"><span className="icon-arrow-up"></span>{this.translations.captchaInvalidRequest}</div>}
                {this.props.invoiceAddressApiIsIncorrect && <div className="validation-advice"><span className="icon-arrow-up"></span>{this.translations.invoiceAddressApiIncorrect}</div>}
                {this.props.deliveryAddressApiIsIncorrect && <div className="validation-advice"><span className="icon-arrow-up"></span>{this.translations.deliveryAddressApiIncorrect}</div>}
                <div id="checkout-review-load" className="default-box">
                </div>                
                <div className="content button-set">
                  <span id="review-buttons-container">
                    <button
                      id="place-order-button"
                      className="button-addToCart"
                      type="button"
                      onClick={() => {
                        if(this.props.showCaptchaV2){
                          this.onContinueClick('');
                        }
                        else {
                          this.getRecaptchaToken("ecommerce");                                
                        }
                      }}
                    >
                      {this.translations.continue}
                    </button>
                  </span>
                </div>      
              </div>
            ) : (
              <Spinner show />
            )}
          </div>
        </div>
      </li>
    );
  }
}

CheckoutBatterySummary.contextType = TranslationsContext;
